import 'core-js/shim';
import { bisector, extent, min, max } from "d3-array";
import { interpolate } from "d3-interpolate";
import { Point, barycentric } from './Geometry';
import { ISample, IDataSet, IDataSequence } from "./Data";

// clips sequence of data points with respect to provided time range of interest
export function clip(samples: ISample[], clip: Date[]): ISample[]
{
    var bisector = bisector<ISample, Date>(s => s.x);
    let l = bisector.left(samples, clip[0]);
    const h = bisector.right(samples, clip[1]);

    var result = samples.slice(l, h);
    if (interpolateSample) {
        if (l>0 && clip[0] !== samples[l].x)
            result.splice(0, 0, interpolateSample(samples[l-1], samples[l], clip[0]));
        if (h<samples.length && clip[1] !== samples[h].x)
            result.push(interpolateSample(samples[h-1], samples[h], clip[1]));
    }
    return result;
}

export function interpolateSample(s1: ISample, s2: ISample, at: Date): ISample
{
    const interpolator = interpolate(s1.y, s2.y);
    const t = barycentric (s1.x, s2.x, at);
    return {
        x: at,
        y: interpolator(t)
    };
}

export function filterDataSets(dataSets: IDataSet[], predicate: (seq: IDataSequence) => boolean): IDataSet[]
{
    return dataSets.map(ds => {
        var dsCopy = Object.assign({}, ds);
        dsCopy.sequences = dsCopy.sequences.filter(predicate);
        return dsCopy;
    });
}

// calculate DataSets extent (min, max)
export function extentDataSets<T extends d3.Numeric> (dataSets: IDataSet[], accessor: (sample: ISample) => T): [T, T]
{
    return extentStream(dataSets.map(ds => extentDataSet(ds, accessor)));
}

export function extentDataSet<T extends d3.Numeric>(dataSet: IDataSet, accessor: (sample: ISample) => T): [T, T]
{
    return extentStream(dataSet.sequences.map(seq => extent<ISample, T>(seq.samples, accessor)));
}

export function extentStream<T extends d3.Numeric>(minMaxSeq: Array<[T, T]>): [T, T]
{
    var minimum = min<[T, T], T>(minMaxSeq, mm => mm[0]);
    var maximum = max<[T, T], T>(minMaxSeq, mm => mm[1]);
    return  [minimum, maximum];
}

// SVG attribute utils

export function translateX(x: number): string
{
    return translateXY(x, 0);
}

export function translateY(y: number): string
{
    return translateXY(0, y);
}

export function translatePoint(p: Point): string
{
    return translateXY(p.x, p.y);     
}

export function translateXY(x: number, y: number): string
{
    return `translate(${x},${y})`;
}

export function px(x: number): string
{
    return `${x}px`;
}


// WEBPACK FOOTER //
// ./src/charts/Utils.ts